var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplePodcast = function SvgApplePodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple-podcast_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.37 27.733c-.309.79-1.023 1.899-2.047 2.688-.587.448-1.291.886-2.251 1.174-1.024.309-2.293.405-3.872.405H8.8c-1.579 0-2.837-.107-3.872-.405a6.654 6.654 0 0 1-2.25-1.174c-1.014-.778-1.74-1.898-2.049-2.688C.011 26.144 0 24.341 0 23.2V8.8c0-1.141.01-2.944.63-4.533.309-.79 1.023-1.899 2.047-2.688C3.264 1.13 3.968.693 4.928.405 5.963.107 7.221 0 8.8 0h14.4c1.579 0 2.837.107 3.872.405.96.288 1.664.715 2.25 1.174 1.014.778 1.74 1.898 2.049 2.688C32 5.856 32 7.669 32 8.8v14.4c0 1.141-.01 2.944-.63 4.533Z",
    fill: "url(#apple-podcast_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.741 19.318c-.042-.384-.17-.662-.426-.918-.48-.501-1.323-.832-2.315-.832s-1.835.32-2.315.832a1.506 1.506 0 0 0-.426.918c-.086.746-.032 1.386.053 2.421.085.981.245 2.293.448 3.616.15.95.267 1.461.373 1.824.182.597.832 1.11 1.867 1.11 1.035 0 1.696-.523 1.867-1.11.106-.363.224-.875.373-1.824.203-1.333.363-2.635.448-3.616.096-1.035.139-1.675.053-2.421ZM18.624 13.877A2.622 2.622 0 0 1 16 16.501a2.622 2.622 0 0 1-2.624-2.624A2.622 2.622 0 0 1 16 11.253a2.629 2.629 0 0 1 2.624 2.624Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.968 3.542c-6.123.02-11.136 4.992-11.221 11.114-.064 4.96 3.104 9.205 7.53 10.763.107.043.214-.053.203-.16-.053-.384-.117-.768-.16-1.152a.423.423 0 0 0-.224-.31c-3.499-1.525-5.941-5.034-5.899-9.098.054-5.333 4.406-9.675 9.728-9.717 5.45-.043 9.899 4.373 9.899 9.813 0 4.021-2.432 7.477-5.899 9.002a.363.363 0 0 0-.224.31l-.16 1.152c-.021.117.096.203.203.16 4.384-1.536 7.53-5.718 7.53-10.624-.02-6.208-5.087-11.264-11.306-11.253Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.712 7.275c-3.99.149-7.19 3.445-7.243 7.434a7.534 7.534 0 0 0 3.296 6.326c.096.064.235-.011.235-.128a10.476 10.476 0 0 1-.01-1.291.434.434 0 0 0-.15-.363 6.1 6.1 0 0 1-1.93-4.608 6.113 6.113 0 0 1 5.855-5.93c3.478-.139 6.336 2.656 6.336 6.09 0 1.75-.746 3.328-1.93 4.448a.508.508 0 0 0-.15.363c.022.416.011.821-.01 1.28-.011.117.128.203.234.128a7.548 7.548 0 0 0 3.296-6.23c.011-4.245-3.541-7.69-7.829-7.52Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apple-podcast_svg__b",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "apple-podcast_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgApplePodcast;